<template>
<div class="flex flex-col items-center justify-center max-w-4xl">
  <p v-if="question" class="font-bold text-4xl mb-4" :key="get_random()">{{ question.label }}</p>

  <slot></slot>

  <Radio 
    v-if="input==='radio'"
    :question="question"
    :options="options"
    :key="get_random()"
  />
  <Checkbox
    v-if="input==='checkbox'" 
    :question="question"
    :options="options"
    :key="get_random()"
  />
  <Slider
    v-if="input==='slider'" 
    :question="question"
    :options="[1, 2, 3, 4, 5, 6, 7, 8 ,9, 10]"
    :key="get_random()"
  />

</div>
</template>

<script>
import { mapState } from 'vuex';
import Radio from '../components/inputs/Radio';
import Checkbox from '../components/inputs/Checkboxes';
import Slider from '../components/inputs/Slider';

export default {
  name: 'Step',
  components: {
    Radio,
    Checkbox,
    Slider,
  },
  props: {
    question: {
      required: false,
      type: Object
    },
    // input and options are not required since technically the results page is a <Step/>, and requires neither
    input: {
      required: false,
      type: String
    },
    options: {
      required: false,
      type: Array
    },
  },
  computed: {
    ...mapState([
      'step'
    ])
  },
  methods: {
    // Random keys ensure the child components (Checkbox, Radio, Slider) are destroyed every time we navigate steps
    get_random() {
      const uuid = (a) => a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
      // console.log(uuid());
      return uuid();
    }
  }
}
</script>
